import React from "react";
import '../../resources/css/application.css';
import iconCompleted from '../../resources/images/icon-completed.svg';
import Header from "../common/Header";
import Footer from "../common/Footer";

function SuccessPage() {

  return (
    <div className="site">

      <Header headerTextFlag={false}/>

      <main className="site-content">

        <div className="container">

          <div className="card card--pullup card--content-center text-center">

            <div className="icon-benefit mb-4">
              <img alt="" src={iconCompleted}/>
            </div>

            <h1 className="headline-1 w-md-75">Dokumenti su uspješno poslani</h1>
            <p className="lead mb-5 w-md-75">Zahvaljujemo, uspješno si poslao/la dokumente za ažuriranje studentskog statusa!</p>

          </div>
        </div>

      </main>

      <Footer/>

    </div>
  );
}

export default SuccessPage;